import {UnsafeHTML} from '../@types/UnsafeHTML';
import AbstractPrintableHttpException from './AbstractPrintableHttpException';

export default class DumpResponseHttpException extends AbstractPrintableHttpException {
    name = 'DumpResponseHttpException';

    constructor(response: Response, protected htmlResponse: UnsafeHTML) {
        super(response, 'Exceptions.services.http.dump_request');
    }

    getMessageComponent(): null {
        return null;
    }

    getHtmlResponse(): UnsafeHTML {
        return this.getDumperRequiredStyles() + this.htmlResponse
            .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            .replace(/z-?index:\s?([\d.]+)/gim, '9');
    }

    protected getDumperRequiredStyles(): UnsafeHTML {
        return '<style>'
            + '.sf-js-enabled pre.sf-dump .sf-dump-compact,'
            + '.sf-js-enabled .sf-dump-str-collapse .sf-dump-str-collapse,'
            + '.sf-js-enabled .sf-dump-str-expand .sf-dump-str-expand{'
            + 'display: initial !important;'
            + '}</style>';
    }
}
